type SizeAndFitAttributes = {
  categories: { categoryId: string; name: string }[];
  attributeKeys: string[];
}[];

export const sizeAndFitAttributesByCategory: SizeAndFitAttributes = [
  {
    categories: [
      {
        categoryId: "600001506",
        name: "Women's Dresses",
      },
    ],
    attributeKeys: [
      "modeldetails",
      "lengthofgarmentbacknecktohem",
      "dressshape",
      "dresslength",
      "sleeve",
    ],
  },
  {
    categories: [
      {
        categoryId: "600001558",
        name: "Women's Shirts & Tops",
      },
    ],
    attributeKeys: [
      "modeldetails",
      "sleeve",
      "lengthofgarmentbacknecktohem",
      "jeantrousercut",
    ],
  },
  {
    categories: [
      {
        categoryId: "600001568",
        name: "Women's Trousers & Leggings",
      },
      {
        categoryId: "9834990046",
        name: "Women's Jeans",
      },
    ],
    attributeKeys: [
      "modeldetails",
      "insideleg",
      "denimrise",
      "denimstyle",
      "jeantrousercut",
      "waistbandtype",
      "womensspecialistfit",
    ],
  },
  {
    categories: [
      {
        categoryId: "600001538",
        name: "Women's Knitwear",
      },
    ],
    attributeKeys: [
      "sleeve",
      "dresslength",
      "lengthofgarmentbacknecktohem",
      "jeantrousercut",
      "modeldetails",
    ],
  },
  {
    categories: [
      {
        categoryId: "8000016892",
        name: "Bras",
      },
      {
        categoryId: "8000016900",
        name: "Sports Bras",
      },
    ],
    attributeKeys: [
      "modeldetails",
      "bratype2",
      "straptype",
      "fasteningposition",
      "womensspecialistfit",
    ],
  },
];
